export default __webpack_public_path__ + "static/media/Project-3-SingleProject-MobileDisplay.7b669b5e.png";